import { SoftwareOnboardingMain } from 'src/components/SoftwareOnboarding';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { AgreementTemplateSettings } from 'src/containers/Escrow/Agreement';

const AgreementSetup = () => {
  const {
    softwareEscrow: { id, agreement },
  } = useSoftwareEscrow();

  return (
    <SoftwareOnboardingMain
      subtitle="Agreement information: Configuration"
      title="Choose your agreement template"
      description="Define the key terms and legal structure of your escrow agreement."
    >
      <div className="max-w-260 w-full mx-auto">
        <AgreementTemplateSettings escrowId={id} isThirdPartyAgreement={Boolean(agreement?.thirdPartyAgreement)} />
      </div>
    </SoftwareOnboardingMain>
  );
};

export default AgreementSetup;
